import React from "react";

import style from "./Map.module.css";
function Map() {
  return (
    <div className={style.imageContainer}>
      <img
        alt="map"
        src="https://invozone.com/wp-content/uploads/2020/04/map.png"
        className={style.image}
      ></img>
    </div>
  );
}

export default Map;
